__turbopack_context__.v({
  "arrowIcon": "hero-text-module__cjoHzq__arrowIcon",
  "buttonGroup": "hero-text-module__cjoHzq__buttonGroup",
  "contactButton": "hero-text-module__cjoHzq__contactButton",
  "headlineHighlight": "hero-text-module__cjoHzq__headlineHighlight",
  "homeHero": "hero-text-module__cjoHzq__homeHero",
  "iconRtlMirror": "hero-text-module__cjoHzq__iconRtlMirror",
  "krailsHero": "hero-text-module__cjoHzq__krailsHero",
  "mainHeading": "hero-text-module__cjoHzq__mainHeading",
  "mainText": "hero-text-module__cjoHzq__mainText",
  "mainTextContainer": "hero-text-module__cjoHzq__mainTextContainer",
  "primaryButtonIcon": "hero-text-module__cjoHzq__primaryButtonIcon",
  "subheader": "hero-text-module__cjoHzq__subheader",
  "subtitleBlock": "hero-text-module__cjoHzq__subtitleBlock",
  "subtitleHighlightIcon": "hero-text-module__cjoHzq__subtitleHighlightIcon",
  "subtitleHighlightItem": "hero-text-module__cjoHzq__subtitleHighlightItem",
  "subtitleHighlightText": "hero-text-module__cjoHzq__subtitleHighlightText",
  "subtitleHighlights": "hero-text-module__cjoHzq__subtitleHighlights",
  "word": "hero-text-module__cjoHzq__word",
  "wordsContainer": "hero-text-module__cjoHzq__wordsContainer",
});
